/**
 * Icons for the menu items in lib/menu-config (that file stays pure — no
 * components — so server code and node tests can read it).
 */
import type { ComponentType } from 'react';
import {
  BarChart, BarChartBig, Bot, CalendarDays, Clapperboard, Grid3x3, GraduationCap, Handshake, Home,
  LayoutDashboard, LifeBuoy, MessagesSquare, Mic, Newspaper, Palette, PenLine, Plus, Presentation,
  Radio, Rss, Scale, ScanLine, Settings, Share, ShieldCheck, ShoppingCart, SlidersHorizontal, Sparkles,
  Star, TrendingUp, Tv, Upload, UserCircle2, UserRound, Users, Vault, Wallet, Wand2, Wheat,
} from 'lucide-react';
import { AngelWings } from '@/components/icons/angel-wings';
import type { MenuIcon } from '@/lib/menu-config';

export const MENU_ICONS: Record<MenuIcon, ComponentType<{ className?: string }>> = {
  home: Home,
  dashboard: LayoutDashboard,
  story: Clapperboard,
  marketplace: ShoppingCart,
  sync: Tv,
  launch: Presentation,
  profile: UserCircle2,
  media: Vault,
  studio: SlidersHorizontal,
  money: Wallet,
  academy: GraduationCap,
  collab: Handshake,
  community: MessagesSquare,
  feed: Rss,
  events: CalendarDays,
  news: Newspaper,
  broadcast: Radio,
  wishlist: Star,
  stats: BarChart,
  bookTalent: Users,
  creatorAi: Sparkles,
  legalAi: Scale,
  spread: Share,
  settings: Settings,
  upload: Upload,
  memo: Mic,
  songIdea: PenLine,
  cover: Wand2,
  snap: ScanLine,
  epx: Grid3x3,
  create: Plus,
  supporters: AngelWings,
  transparency: TrendingUp,
  whyBb: Wheat,
  charts: BarChartBig,
  themes: Palette,
  help: LifeBuoy,
  admin: ShieldCheck,
  hermes: Bot,
  account: UserRound,
};
